import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import QuickDemoDialog from "@/components/QuickDemoDialog";

export default function CtaSection() {
  return (
    <section data-testid="cta-section" className="bg-slate-950 text-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20 md:py-28 grid md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-8">
          <div className="text-xs uppercase tracking-widerest text-slate-400 font-mono-plex">Reserve your demo seat</div>
          <h2 className="mt-3 font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl leading-tight">
            ₹500 seat-hold. Full course fee only after you attend the demo.
          </h2>
          <p className="mt-4 text-slate-300 max-w-2xl text-base leading-relaxed">
            Pay ₹500 via UPI to block your seat, sit through a live class, meet the trainer, and get a personalised
            career track from Gurudeva. If it isn&apos;t for you, no strings attached.
          </p>
        </div>
        <div className="md:col-span-4 flex md:justify-end flex-col md:items-end gap-3">
          <Link
            to="/pay-demo"
            data-testid="cta-pay-demo-btn"
            className="inline-flex items-center gap-2 bg-white text-slate-950 hover:bg-[#FACC15] font-medium px-6 py-4 transition-colors"
          >
            Pay ₹500 & book demo <ArrowUpRight className="w-4 h-4" />
          </Link>
          <QuickDemoDialog testIdPrefix="cta-quick-demo">
            <button
              type="button"
              data-testid="cta-contact-demo-btn"
              className="text-sm text-slate-300 hover:text-white underline underline-offset-4"
            >
              or just contact us for pricing
            </button>
          </QuickDemoDialog>
        </div>
      </div>
    </section>
  );
}
